import { Controller, useFormContext } from 'react-hook-form';
import { RadioGroup, RadioGroupItem } from '@zep-us/zus';
import { QUIZ_GROUP_MIN_TERM, QUIZ_GROUP_MIN_USERS, QUIZ_GROUP_PRO_UNIT_PRICE, QUIZ_QUOTE_UNIT_PRICE } from '../constants/quizQuote.const';
import { type QuizQuoteFormValues } from '../utils/quizQuote.schema';
import { QuoteSection } from './QuoteSection';
const won = (value: number) => value.toLocaleString('ko-KR');

// Figma: 24×24 컨테이너(padding 2px = 중앙정렬) 안에 20×20 라디오 아이콘.
// 빌드된 ZUS RadioGroupItem 기본이 16px(h-4 w-4)라 여기서 명시 오버라이드한다.
const RADIO_WRAP = 'flex h-6 w-6 shrink-0 items-center justify-center';
const RADIO_ICON = 'h-5 w-5 shrink-0';

/**
 * 요금제 유형 — Pro 플랜에서 개인/학교·단체 단가(할인) 선택 (Figma 13614-55984).
 * plan_type 을 사용자 선택으로 결정한다(개인 50,000 / 학교·단체 30,000, 40% 할인).
 */
export function PlanTypeSection() {
  const {
    control
  } = useFormContext<QuizQuoteFormValues>();
  return <QuoteSection title="요금제 유형" data-sentry-element="QuoteSection" data-sentry-component="PlanTypeSection" data-sentry-source-file="PlanTypeSection.tsx">
      <Controller control={control} name="plan_type" render={({
      field
    }) => <RadioGroup value={field.value} onValueChange={field.onChange} className="gap-lg">
            <label className="flex cursor-pointer items-start gap-sm">
              <span className={RADIO_WRAP}>
                <RadioGroupItem value="individual" className={RADIO_ICON} />
              </span>
              <div className="flex flex-col gap-4xs">
                <span className="text-body-lg-bold text-default">개인</span>
                <span className="text-body-sm-medium text-alternative">
                  인당 월 {won(QUIZ_QUOTE_UNIT_PRICE.pro)}원
                </span>
              </div>
            </label>

            <label className="flex cursor-pointer items-start gap-sm">
              <span className={RADIO_WRAP}>
                <RadioGroupItem value="group" className={RADIO_ICON} />
              </span>
              <div className="flex flex-col gap-4xs">
                <span className="flex items-center gap-2xs">
                  <span className="text-body-lg-bold text-default">
                    학교·단체
                  </span>
                  <span className="text-caption-md-medium text-pink-400">
                    40% 할인
                  </span>
                </span>
                <span className="text-body-sm-medium text-alternative">
                  인당 월 {won(QUIZ_GROUP_PRO_UNIT_PRICE)}원 (최소{' '}
                  {QUIZ_GROUP_MIN_USERS}명, {QUIZ_GROUP_MIN_TERM}개월 이상)
                </span>
              </div>
            </label>
          </RadioGroup>} data-sentry-element="Controller" data-sentry-source-file="PlanTypeSection.tsx" />
    </QuoteSection>;
}